"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:!0}),exports.History=exports.CashbackAmount=exports.Amount=exports.ActivityInfo=void 0;var _styledComponents=_interopRequireDefault(require("styled-components")),_global=require("../../../constants/global.constants");const History=exports.History=_styledComponents.default.div`
max-height:400px;
overflow-y:scroll;
scroll-behavior: smooth;

::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the scrollbar thumb */
    border-radius: 4px; /* Rounded corners for the scrollbar thumb */
  }

  /* Force scrollbar thumb to always be visible */
  &::after {
    content: '';
    display: block;
    margin-top: -2px; /* Negative margin to avoid affecting layout */
}
.history{
    display: flex;
    padding: 4px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background-color:#F1F0EE;
    margin-top: 5px;
}

.history > div {
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px;
color:#535250;
}

.account{
    display: flex;
padding: 6px 16px;
align-items: center;
align-self: stretch;
gap:10px

.detail+ div{
    color:  #2A2928;
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
text-align: right;
font-feature-settings: 'liga' off, 'calt' off;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 18px;
}

.detail {
    font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    flex: 1 0 0;
    line-height: 0;
}

.sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}

.expiresLabel{
    background: ${_global.labelColor[_global.Themes[_global.Banner]]};
    border-radius: 4px;
    margin-left: 4px;
    padding: 2px 4px;
}

.detail>p:nth-child(1){
    display: flex;
width: 247px;
flex-direction: column;
justify-content: center;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 10px; 
color:#2A2928;
margin-bottom: 0px;

}
.margin{
    margin-left: 2px;
}
.labelstyle{
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color:#2A2928;
    background: #FAF9F8;
    padding: 4px 2px 4px 4px;
    border-radius: 2px;
    /* margin-bottom: 3px; */
    }
.dontApply{
    margin-bottom: 3px;
}
.detail>p:nth-child(2):not(.dontApply){
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color:#2A2928;
    background: #FAF9F8;
    padding: 2px 2px 2px 4px;
    border-radius: 2px;
    margin-bottom: 3px;
    }

    .orderNumber{
    font-weight:600;
    }
    p{
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
`,Amount=exports.Amount=_styledComponents.default.div`
    color: ${a=>"SALE"===a?.transactionType?"red":"black"};
`,CashbackAmount=exports.CashbackAmount=_styledComponents.default.div`
    color: ${a=>"SALE"===a?.transactionType||"CAPTURE"===a?.transactionType||"AUTH"===a?.transactionType?"red":"black"};
`,ActivityInfo=exports.ActivityInfo=_styledComponents.default.div`
    display: block;
    padding: 0px 16px 10px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background-color: #FFFFFF;

    .activity{
        font-weight:600;
        font-size: 14px;
        margin-top: 12px;
    }

    p{
        margin-bottom: 2px;
    }
`;